import React from 'react'
import TextSection from '../components/TextSection'
import GlobalHiring from '../components/GlobalHiring'
import HireSection from '../components/HireSection'
import { hiringsectionincompany } from '../data/HiresectionData'
import { textsection_one } from '../data/TextsectionData'
import { companytestimonials, companyslidercontent } from '../data/Testimonialdata'
import TestimonialSlider from '../components/TestimonialSlider'
import Hero from '../components/Hero'
import { companyservices, headings } from '../data/GlobalHiringData'
import { useNavigate } from 'react-router-dom'

const CompaniesHiring = () => {
  const navigate = useNavigate();
    const buttons = [
        { text: "Speak to an expert" , buttonClass: "companyFirstbutton"  },
      ];
  return (
    <>
    <Hero
      title="Companies Hiring Internationally"
      description="Looking to expand your business and hire global talent? Managing international employment can be complex with varying compliance, tax, and regulatory requirements in every country. That’s where Ampstekpay steps in to ease your burden."
      buttonText="Connect with Expert"
      customClass="CompanyHiringBanner"
      imageSrc="images/hero.jpg"
      squareColor="CompanyHiringsquare-bg-color"
      onButtonClick={() => navigate('/meet-the-experts')}
    />
    <TextSection  data={textsection_one} withSpan={true}/>
    <GlobalHiring services={companyservices} customClass="companyhiringGlobal" heading={headings.page1}/>
    <TestimonialSlider testimonials={companytestimonials} sliderContent={companyslidercontent} customClass="homepagetestimonial"/>
    <HireSection
        imageSrc={hiringsectionincompany.imageSrc}
        title={hiringsectionincompany.title}
        description={hiringsectionincompany.description}
        buttonText={buttons}
        className={hiringsectionincompany.className}
      />
    </>
  )
}

export default CompaniesHiring